import store from "../../store";

const locales = store.state.locales
const localesKeys = Object.keys(locales)
const origin = window.location.origin

export default function setAlternate($route, localesForCheck) {
  let path = $route.path

  if(path.startsWith(`/${store.state.currentLocale}/`)) {
    path = path.slice(3)
  }

  for (let lang of localesKeys) {
    if(localesForCheck && !localesForCheck[lang]) {
      removeTag(lang)
      continue
    }
    const href = `${origin}${lang === 'ua' ? '' : '/' + lang}${path}`
    setHref(href, lang)
  }
}

function setHref(href, lang) {
  let hreflang = createHreflang(lang)

  const tag = document.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`) || createTag(hreflang)
  tag.setAttribute('href', href)

  return tag
}

function createTag(hreflang) {
  const tag = document.createElement('link')
  tag.setAttribute('rel', 'alternate')
  tag.setAttribute('hreflang', hreflang)

  document.head.appendChild(tag)
  return tag
}

function createHreflang(lang) {
  return locales[lang] &&
      locales[lang].regional &&
      locales[lang].regional.replace('_', '-') ||
      lang
}

function removeTag(lang) {
  let hreflang = createHreflang(lang)
  const tag = document.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`)
  if (tag) {
    document.head.removeChild(tag)
  }
}

function removeAllAlternate() {
  const tags = document.querySelectorAll(`link[rel="alternate"]`)
  if(tags) {
    tags.forEach(tag => {
      tag.parentElement.removeChild(tag)
    })
  }
}

export {removeAllAlternate, setHref}
